import { Component, Input } from '@angular/core';
import {MainStoreService} from "@cybfed/core/store/main.store.service";
import {CardModel} from "@white-label/components/page-builder/models/card.model";
import {VideoPlayerComponent} from "@white-label/components/white-label/video-player/video-player.component";
import {CommonModule} from "@angular/common";
import {CheckMediaType, MediaTypes} from "@cybfed/core/utils/check-media-type";

@Component({
    selector: 'white-label-media-card',
    standalone: true,
    imports: [
        VideoPlayerComponent,
        CommonModule
    ],
    providers: [],
    templateUrl: './media-card.component.html'
})
export class MediaCardComponent {
    @Input() componentModel: CardModel =  new CardModel();
    groupId = Date.now();
    constructor(public mainStore: MainStoreService) {
    }

    playVideo(){

    }

    protected readonly CheckMediaType = CheckMediaType;
    protected readonly MediaTypes = MediaTypes;
}
